import React from 'react';
import { Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface GoBackButtonProps {
  label?: string;
  sx?: object;
  /** Optional side effect run immediately before navigating back (e.g. cache invalidation). */
  onBeforeNavigate?: () => void;
}

const GoBackButton: React.FC<GoBackButtonProps> = ({ 
  label = 'Go Back',
  sx = {},
  onBeforeNavigate
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    onBeforeNavigate?.();
    navigate(-1);
  };

  return (
    <Button
      variant="outlined"
      onClick={handleGoBack}
      startIcon={<ArrowBackIcon />}
      sx={{
        color: '#64748b',
        borderColor: '#e2e8f0',
        fontWeight: 600,
        px: 3,
        py: 1,
        '&:hover': {
          backgroundColor: '#f8fafc',
          borderColor: '#cbd5e1'
        },
        ...sx
      }}
    >
      {label}
    </Button>
  );
};

export default GoBackButton;
